import type { ReactNode } from 'react';
import GradientBackground from './GradientBackground';

interface LayoutProps {
  children: ReactNode;
  className?: string;
}

export default function Layout({ children, className }: LayoutProps) {
  return (
    <GradientBackground>
      <div className={className}>
        {children}
      </div>
    </GradientBackground>
  );
}
